import { render } from "./GynaeHistoryTab.vue?vue&type=template&id=acf72c36"
import script from "./GynaeHistoryTab.vue?vue&type=script&lang=js"
export * from "./GynaeHistoryTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__